export default function trackEvent(tag, errorMsg = null) {
  if (process.env.NODE_ENV === 'development' && (typeof (tag) === 'undefined' || tag === '' || tag === null)) {
    throw new Error('Dev Error: Must pass a tag to trackEvent.');
  }

  if (tag && typeof (satelliteTrack) !== 'undefined') {
    satelliteTrack(tag, errorMsg);
  }
}
